import {
  IconBasketAdd,
  IconGift,
  IconPen,
  IconPlusRounded,
  IconTrash,
} from "@aksara-ui/icons";
import {
  Badge,
  Box,
  Button,
  Card,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  Text,
  theme,
} from "@aksara-ui/react";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import {
  getAllCatalogCategories,
  getAllCatalogs,
  getAllTenantsFilter,
  setModalConfirmationOpen,
  setModalDescriptionOpen,
  setModalFormOpen,
} from "redux/actions";
import styled from "styled-components";
import moment from "moment";
import {
  CatalogCategoryFormModal,
  CatalogConfirmationModal,
  CatalogDescriptionFormModal,
  CatalogFormModal,
} from "./components";
import { CatalogStocksContent } from "./CatalogStocks";
import {
  Pagination,
  PaginationDetail,
  PaginationFilter,
} from "components/Pagination";
import { InputSearchbox } from "components/Form/InputSearchbox";
import FilterKit from "components/FilterKit";
import { getRole } from "hooks";
import { Link } from "react-router-dom";
import LazyLoadImageWithBlurHash from "components/LazyLoadImageWithBlurHash";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 20px;
`;

const CatalogsContent: React.FC = () => {
  const dispatch = useDispatch();
  const userRole = getRole();
  const isMobile = useMediaQuery({ maxWidth: 576 });
  const isTablet = useMediaQuery({ maxWidth: 1024 });

  const {
    appUrl,
    isLoading,
    isModalFormOpen,
    isModalConfirmationOpen,
    isModalDescriptionOpen,
  } = useSelector((state: any) => state.globalReducer);
  const { catalogs } = useSelector((state: any) => state.catalogReducer);
  const { currentPage, totalPage, limitPage, lengthPage, filterTenantPage } =
    useSelector((state: any) => state.catalogReducer);
  const { tenantsFilter } = useSelector((state: any) => state.tenantReducer);

  const [searchValue, setSearchValue] = useState("");
  const [limit, setLimit] = useState(10);
  const [selectedCatalogId, setSelectedCatalogId] = useState("");
  const [modalCatalogStocksOpen, setModalCatalogStocksOpen] = useState(false);
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  const handleSearchChange = (event: any) => {
    setSearchValue(event.target.value);
    dispatch(
      getAllCatalogs(1, event.target.value, limitPage, filterTenantPage) as any
    );
  };

  const handleClearSearchChange = () => {
    setSearchValue("");
    dispatch(
      getAllCatalogs(currentPage, "", limitPage, filterTenantPage) as any
    );
  };

  const handleOpenFormModal = (catalogId: string = "") => {
    dispatch(setModalFormOpen(true) as any);
    setSelectedCatalogId(catalogId);
  };

  const handleCloseFormModal = () => {
    dispatch(setModalFormOpen(false) as any);
    setSelectedCatalogId("");
  };

  const handleOpenConfirmModal = (catalogId: string) => {
    dispatch(setModalConfirmationOpen(true) as any);
    setSelectedCatalogId(catalogId);
  };

  const handleCloseConfirmModal = () => {
    dispatch(setModalConfirmationOpen(false) as any);
    setSelectedCatalogId("");
  };

  const handleOpenCatalogStocksModal = (catalogId: string) => {
    setModalCatalogStocksOpen(true);
    setSelectedCatalogId(catalogId);
  };

  const handleCloseCatalogStocksModal = () => {
    setModalCatalogStocksOpen(false);
    setSelectedCatalogId("");
  };

  const handleOpenCatalogDescriptionFormModal = (catalogId: string) => {
    dispatch(setModalDescriptionOpen(true) as any);
    setSelectedCatalogId(catalogId);
  };

  const handleCloseCatalogDescriptionFormModal = () => {
    dispatch(setModalDescriptionOpen(false) as any);
    setSelectedCatalogId("");
  };

  useEffect(() => {
    dispatch(getAllTenantsFilter() as any);
    dispatch(getAllCatalogCategories() as any);
    dispatch(getAllCatalogs() as any);
    dispatch({
      type: "SET_CATALOG_GIFT",
      value: [],
    });
  }, [dispatch]);

  const handleOpenCategoryModal = (category: any = null) => {
    setSelectedCategory(category);
    setIsCategoryModalOpen(true);
  };
  const handleCloseCategoryModal = () => {
    setSelectedCategory(null);
    setIsCategoryModalOpen(false);
  };

  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <HeaderWrapper
        display={"flex"}
        flexDirection={"column"}
        style={{ gap: 20 }}
      >
        <Box display={"flex"}>
          <Text scale={[500, 600]} fontWeight={700}>
            Physical Goods
          </Text>
        </Box>

        <Box
          display={"flex"}
          flexDirection={isMobile ? "column" : "row"}
          justifyContent={"space-between"}
          style={{ gap: isMobile ? 10 : 20 }}
        >
          <Box
            display={"flex"}
            flexDirection={isTablet ? "column" : "row"}
            justifyContent={"space-between"}
            style={{ gap: 5 }}
          >
            <InputSearchbox
              autoComplete="off"
              name="textDummy"
              placeholder="Search..."
              size={32}
              onChange={handleSearchChange}
              onClearButton={handleClearSearchChange}
            />

            {userRole === "superadmin" ? (
              <FilterKit
                orderByOptions={[
                  {
                    key: tenantsFilter,
                    label: "Tenant",
                    options: tenantsFilter.map((tenant: any) => {
                      return {
                        label: tenant.name,
                        value: tenant.id,
                      };
                    }),
                  },
                ]}
                onChangeOrder={(e: any) => {
                  dispatch(
                    getAllCatalogs(
                      1,
                      "",
                      limitPage,
                      e[tenantsFilter] ? e[tenantsFilter].value : ""
                    ) as any
                  );
                }}
              />
            ) : (
              <></>
            )}
          </Box>

          <Stack
            display={"flex"}
            justifyContent={"right"}
            flexDirection={"row"}
            style={{ gap: isMobile ? 10 : 20 }}
          >
            <Button
              variant="outline"
              borderRadius={10}
              style={{ fontWeight: 600 }}
              size={32}
              onClick={handleOpenCategoryModal}
            >
              Add Category
            </Button>
            <Button
              variant="primary"
              borderRadius={10}
              style={{ fontWeight: 600 }}
              icon={IconPlusRounded}
              iconPosition={"left"}
              size={32}
              onClick={() => handleOpenFormModal()}
            >
              Add Catalog
            </Button>
          </Stack>
        </Box>
      </HeaderWrapper>

      <Card overflow={"auto"} elevation={2} maxHeight={"100%"}>
        <Table>
          <TableHead
            position={"sticky"}
            top={0}
            backgroundColor={theme.colors.grey02}
          >
            <TableHeadRow>
              <TableHeadCell>Catalog Name</TableHeadCell>
              <TableHeadCell minWidth={150}>Image</TableHeadCell>
              <TableHeadCell>Product</TableHeadCell>
              <TableHeadCell>Points Needed</TableHeadCell>
              <TableHeadCell>Expiry Date</TableHeadCell>
              <TableHeadCell>Point Type</TableHeadCell>
              <TableHeadCell>Push Reward</TableHeadCell>
              <TableHeadCell>Action</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={8} />
            ) : !catalogs.length ? (
              <TableBodyRow>
                <TableBodyCell colSpan={8} textAlign={"center"}>
                  No data available in table
                </TableBodyCell>
              </TableBodyRow>
            ) : (
              catalogs.map((catalog: any) => {
                return (
                  <TableBodyRow key={catalog.id}>
                    <TableBodyCell
                      onClick={() =>
                        handleOpenCatalogDescriptionFormModal(catalog.id)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {catalog.catalog_name}
                    </TableBodyCell>
                    <TableBodyCell
                      onClick={() =>
                        handleOpenCatalogDescriptionFormModal(catalog.id)
                      }
                      style={{ cursor: "pointer", height: 150, width: 140 }}
                    >
                      {catalog.img_url ? (
                        <LazyLoadImageWithBlurHash
                          key={catalog.id}
                          src={`${appUrl}/storage/${catalog.img_url}`}
                          blurHash="LEHV6nWB2yk8pyo0adR*.7kCMdnj"
                          alt="catalog-image"
                          height={"auto"}
                          width={140}
                          style={{
                            borderRadius: 10,
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </TableBodyCell>
                    <TableBodyCell
                      onClick={() =>
                        handleOpenCatalogDescriptionFormModal(catalog.id)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <Badge size="md" variant="default">
                        {catalog.catalog_product}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell
                      whiteSpace={"nowrap"}
                      onClick={() =>
                        handleOpenCatalogDescriptionFormModal(catalog.id)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <Badge size="md" variant="info">
                        {(parseInt(catalog.points_needed) || 0).toLocaleString()} Pts
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell
                      onClick={() =>
                        handleOpenCatalogDescriptionFormModal(catalog.id)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      {moment(catalog.expiry_date).format("DD MMM YYYY")}
                    </TableBodyCell>
                    <TableBodyCell
                      whiteSpace={"nowrap"}
                      onClick={() =>
                        handleOpenCatalogDescriptionFormModal(catalog.id)
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <Badge size="md" variant="info">
                        {catalog.point_type_used === "0"
                          ? "XP Point"
                          : catalog.point_type_used === "1"
                          ? "Referral Point"
                          : "Push Reward"}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell whiteSpace={"nowrap"} textAlign={"center"}>
                      <Link to={`/products/gifts/${catalog.id}`}>
                        <IconButton
                          borderRadius={50}
                          size={32}
                          style={{
                            fontWeight: 600,
                            backgroundColor: theme.colors.blue06,
                          }}
                          type={"button"}
                        >
                          <IconGift fill={"white"} />
                        </IconButton>
                      </Link>
                    </TableBodyCell>
                    <TableBodyCell>
                      <IconButton
                        onClick={() => handleOpenCatalogStocksModal(catalog.id)}
                      >
                        <IconBasketAdd fill={theme.colors.blue06} />
                      </IconButton>
                      <IconButton
                        onClick={() => handleOpenFormModal(catalog.id)}
                      >
                        <IconPen fill={theme.colors.green06} />
                      </IconButton>
                      <IconButton
                        onClick={() => handleOpenConfirmModal(catalog.id)}
                      >
                        <IconTrash fill={theme.colors.red06} />
                      </IconButton>
                    </TableBodyCell>
                  </TableBodyRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Card>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingY={10}
      >
        {!isMobile ? (
          <PaginationDetail
            page={currentPage}
            limit={limitPage}
            length={lengthPage}
          />
        ) : (
          ""
        )}
        <Pagination
          current={currentPage}
          total={totalPage}
          onSelect={(select: any) =>
            dispatch(
              getAllCatalogs(
                select,
                searchValue,
                limitPage,
                filterTenantPage
              ) as any
            )
          }
        />
        <PaginationFilter
          selectedItem={limit}
          onChange={(selectedItem) => {
            if (selectedItem) {
              setLimit(selectedItem);
              dispatch(
                getAllCatalogs(
                  1,
                  searchValue,
                  selectedItem,
                  filterTenantPage
                ) as any
              );
            }
          }}
          items={[10, 20, 30, 40, 50]}
        />
      </Box>

      <CatalogCategoryFormModal
        isOpen={isCategoryModalOpen}
        onClose={handleCloseCategoryModal}
        currentCategory={selectedCategory}
        mode={selectedCategory ? "edit" : "create"}
        onCategoryCreated={() => dispatch(getAllCatalogCategories() as any)}
      />

      <CatalogFormModal
        catalogId={selectedCatalogId}
        isOpen={isModalFormOpen}
        onClose={() => handleCloseFormModal()}
      />

      <CatalogConfirmationModal
        catalogId={selectedCatalogId}
        isOpen={isModalConfirmationOpen}
        onClose={() => handleCloseConfirmModal()}
      />

      <CatalogStocksContent
        catalogId={selectedCatalogId}
        type={"Catalog"}
        isOpen={modalCatalogStocksOpen}
        onClose={() => handleCloseCatalogStocksModal()}
      />

      <CatalogDescriptionFormModal
        catalogId={selectedCatalogId}
        isOpen={isModalDescriptionOpen}
        onClose={() => handleCloseCatalogDescriptionFormModal()}
      />
    </Box>
  );
};

export default CatalogsContent;
